<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="search-inner">
      <a-form layout="inline">
        <a-form-item class="name" label="学期名称">
          <a-input class="form-cell" type="text" placeholder="请输入" v-model="queryParam.termName"></a-input>
        </a-form-item>

        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchTerm()">查询</a-button>
          <a-button type="primary" @click="() => queryParam = {}">重置</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="list-oper">
      <a-button type="primary" icon="plus" @click="$refs.termForm.init('add')">新建</a-button>
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="termList"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
    >
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="$refs.termForm.init('update',record)">修改</a>
          <a-divider type="vertical" />
          <a @click="deleteTerm(record)">删除</a>
        </template>
      </span>
    </a-table>
    <term-form-modal ref="termForm" @addTerm="addTerm" @updateTerm="updateTerm"></term-form-modal>
  </div>
</template>
<script>
import term from "../../api/term";

import TermFormModal from "./TermFormModal";


const columns = [
  {
    title: "学期名称",
    dataIndex: "termName",
  },
  {
    title: "开始日期",
    dataIndex: "startDate",
  },
  {
    title: "结束日期",
    dataIndex: "endDate",
  },
  {
    title: "创建时间",
    dataIndex: "gmtCreate",
    sorter: true
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "termList",
  data() {
    return {
      termList: [], //学期数据
      columns, //列标识数据
      queryParam: {}, //查询参数
      pagination: { 
				showTotal: total => `总共 ${total} 条`, // 显示总数
      }, //分页数据对象
      loading: true,
    };
  },
  components: {
    TermFormModal
  },
  methods: {
    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地址的话，把地址解析之后带入
      let obj = this.queryParam;
      obj.currentPage = pagination.current;
      //存在排序的时候
      if(sorter && sorter.columnKey){
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == "ascend" ? "asc" : "desc"
        }`;
      }
      this.getTermList(obj);
    },

    //新增一个学期
    addTerm(value) {
      this.termList.unshift(value);
    },

    //删除学期
    deleteTerm(value) {
      let self = this;
      this.$confirm({
        title: "确定要删除吗?",
        okText: "确定",
        cancelText: "取消",
        content: "删除后，无法撤销",
        onOk() {
          term.deleteTerm(value.id).then(res => {
            self.$message.success("删除成功");
            //前端模拟删除
            self.deleteTermData(self.termList, value.id);
          });
        }
      });
    },

    //删除数据
    deleteTermData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1);
          break;
        }
      }
    },

    //修改学期
    updateTerm(term){
      for(let i in this.termList){
        if(this.termList[i].id == term.id){
          this.$set(this.termList,i,term)
        }
      }
    },

    //查询学期
    searchTerm() {
      this.queryParam.currentPage = 1;
      this.getTermList(this.queryParam);
    },

    //学期列表
    getTermList(params) {
      this.loading = true;
      term.getTermList(params).then(res => {
        console.log("当前的学期列表是", res.data.list);
        this.termList = res.data.list;
        this.loading = false;
        //分页信息
        this.pagination = res.data.pagination;
      });
    },
  },
  created() {
    this.getTermList();
  }
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}

.search-oper {
  button {
    margin: 0px 5px;
  }
}
.list-oper {
  margin: 20px 0px 30px;
}
.price-scope{
  width: 100px; 
  text-align: center; 
}
.max-price{
  border-left: none;
}
.price-gap{
  width: 30px; 
  border-left: 0; 
  pointer-events: none; 
  background: #fff;
}
</style>